import { useTheme } from '@mui/material';
import { memo } from 'react';

type PropsTypes = {
  color?: string;
};
function XCircle({ color }: PropsTypes) {
  const theme = useTheme();
  const ERROR_MAIN = theme.palette.error.main;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.44444 9.55556L8 8M8 8L9.55556 6.44444M8 8L6.44444 6.44444M8 8L9.55555 9.55556M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        stroke={color ?? ERROR_MAIN}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(XCircle);
